/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalComments } from './AdditionalComments';
import {
    AdditionalCommentsFromJSON,
    AdditionalCommentsFromJSONTyped,
    AdditionalCommentsToJSON,
} from './AdditionalComments';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage1 } from './BuyerAgentCommissionPercentage1';
import {
    BuyerAgentCommissionPercentage1FromJSON,
    BuyerAgentCommissionPercentage1FromJSONTyped,
    BuyerAgentCommissionPercentage1ToJSON,
} from './BuyerAgentCommissionPercentage1';
import type { BuyerAgentEmail } from './BuyerAgentEmail';
import {
    BuyerAgentEmailFromJSON,
    BuyerAgentEmailFromJSONTyped,
    BuyerAgentEmailToJSON,
} from './BuyerAgentEmail';
import type { BuyerAgentFullName } from './BuyerAgentFullName';
import {
    BuyerAgentFullNameFromJSON,
    BuyerAgentFullNameFromJSONTyped,
    BuyerAgentFullNameToJSON,
} from './BuyerAgentFullName';
import type { BuyerAgentPhone } from './BuyerAgentPhone';
import {
    BuyerAgentPhoneFromJSON,
    BuyerAgentPhoneFromJSONTyped,
    BuyerAgentPhoneToJSON,
} from './BuyerAgentPhone';
import type { BuyerEmail } from './BuyerEmail';
import {
    BuyerEmailFromJSON,
    BuyerEmailFromJSONTyped,
    BuyerEmailToJSON,
} from './BuyerEmail';
import type { BuyerPhone } from './BuyerPhone';
import {
    BuyerPhoneFromJSON,
    BuyerPhoneFromJSONTyped,
    BuyerPhoneToJSON,
} from './BuyerPhone';
import type { BuyerRepresentation } from './BuyerRepresentation';
import {
    BuyerRepresentationFromJSON,
    BuyerRepresentationFromJSONTyped,
    BuyerRepresentationToJSON,
} from './BuyerRepresentation';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage1 } from './ConcessionsPercentage1';
import {
    ConcessionsPercentage1FromJSON,
    ConcessionsPercentage1FromJSONTyped,
    ConcessionsPercentage1ToJSON,
} from './ConcessionsPercentage1';
import type { CreateOfferRequestSource } from './CreateOfferRequestSource';
import {
    CreateOfferRequestSourceFromJSON,
    CreateOfferRequestSourceFromJSONTyped,
    CreateOfferRequestSourceToJSON,
} from './CreateOfferRequestSource';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingType } from './FinancingType';
import {
    FinancingTypeFromJSON,
    FinancingTypeFromJSONTyped,
    FinancingTypeToJSON,
} from './FinancingType';
import type { ManualEntryReason } from './ManualEntryReason';
import {
    ManualEntryReasonFromJSON,
    ManualEntryReasonFromJSONTyped,
    ManualEntryReasonToJSON,
} from './ManualEntryReason';
import type { MlsId } from './MlsId';
import {
    MlsIdFromJSON,
    MlsIdFromJSONTyped,
    MlsIdToJSON,
} from './MlsId';
import type { OfferSource } from './OfferSource';
import {
    OfferSourceFromJSON,
    OfferSourceFromJSONTyped,
    OfferSourceToJSON,
} from './OfferSource';
import type { ReceivedAt } from './ReceivedAt';
import {
    ReceivedAtFromJSON,
    ReceivedAtFromJSONTyped,
    ReceivedAtToJSON,
} from './ReceivedAt';
import type { SubmissionAdditionalTerms } from './SubmissionAdditionalTerms';
import {
    SubmissionAdditionalTermsFromJSON,
    SubmissionAdditionalTermsFromJSONTyped,
    SubmissionAdditionalTermsToJSON,
} from './SubmissionAdditionalTerms';

/**
 * 
 * @export
 * @interface CreateOfferRequest
 */
export interface CreateOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    listingId: string;
    /**
     * 
     * @type {MlsId}
     * @memberof CreateOfferRequest
     */
    mlsId?: MlsId;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    buyerFullName: string;
    /**
     * 
     * @type {BuyerPhone}
     * @memberof CreateOfferRequest
     */
    buyerPhone?: BuyerPhone;
    /**
     * 
     * @type {BuyerEmail}
     * @memberof CreateOfferRequest
     */
    buyerEmail?: BuyerEmail;
    /**
     * 
     * @type {BuyerRepresentation}
     * @memberof CreateOfferRequest
     */
    buyerRepresentation: BuyerRepresentation;
    /**
     * 
     * @type {BuyerAgentFullName}
     * @memberof CreateOfferRequest
     */
    buyerAgentFullName?: BuyerAgentFullName;
    /**
     * 
     * @type {BuyerAgentPhone}
     * @memberof CreateOfferRequest
     */
    buyerAgentPhone?: BuyerAgentPhone;
    /**
     * 
     * @type {BuyerAgentEmail}
     * @memberof CreateOfferRequest
     */
    buyerAgentEmail?: BuyerAgentEmail;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    offerPrice: number;
    /**
     * 
     * @type {Array<FinancingType>}
     * @memberof CreateOfferRequest
     */
    financingTypes: Array<FinancingType>;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    downPayment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    earnestMoneyDeposit: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    dueDiligencePeriodDays: number;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof CreateOfferRequest
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof CreateOfferRequest
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    closingDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    titleCompany: string;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof CreateOfferRequest
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof CreateOfferRequest
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage1}
     * @memberof CreateOfferRequest
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage1;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof CreateOfferRequest
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof CreateOfferRequest
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfferRequest
     */
    requestSellerConcessions: boolean;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof CreateOfferRequest
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage1}
     * @memberof CreateOfferRequest
     */
    concessionsPercentage?: ConcessionsPercentage1;
    /**
     * 
     * @type {SubmissionAdditionalTerms}
     * @memberof CreateOfferRequest
     */
    submissionAdditionalTerms?: SubmissionAdditionalTerms;
    /**
     * 
     * @type {AdditionalComments}
     * @memberof CreateOfferRequest
     */
    additionalComments?: AdditionalComments;
    /**
     * 
     * @type {CreateOfferRequestSource}
     * @memberof CreateOfferRequest
     */
    source?: CreateOfferRequestSource;
    /**
     * 
     * @type {ReceivedAt}
     * @memberof CreateOfferRequest
     */
    receivedAt?: ReceivedAt;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfferRequest
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    helpscoutLink?: string;
    /**
     * 
     * @type {ManualEntryReason}
     * @memberof CreateOfferRequest
     */
    manualEntryReason?: ManualEntryReason;
    /**
     * 
     * @type {OfferSource}
     * @memberof CreateOfferRequest
     */
    offerSource?: OfferSource;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    lenderName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    lenderContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    lenderEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    lenderPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    loanId?: string;
}

/**
 * Check if a given object implements the CreateOfferRequest interface.
 */
export function instanceOfCreateOfferRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "listingId" in value;
    isInstance = isInstance && "buyerFullName" in value;
    isInstance = isInstance && "buyerRepresentation" in value;
    isInstance = isInstance && "offerPrice" in value;
    isInstance = isInstance && "financingTypes" in value;
    isInstance = isInstance && "earnestMoneyDeposit" in value;
    isInstance = isInstance && "dueDiligencePeriodDays" in value;
    isInstance = isInstance && "closingDate" in value;
    isInstance = isInstance && "titleCompany" in value;
    isInstance = isInstance && "requestSellerConcessions" in value;

    return isInstance;
}

export function CreateOfferRequestFromJSON(json: any): CreateOfferRequest {
    return CreateOfferRequestFromJSONTyped(json, false);
}

export function CreateOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOfferRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'listingId': json['listing_id'],
        'mlsId': !exists(json, 'mls_id') ? undefined : MlsIdFromJSON(json['mls_id']),
        'buyerFullName': json['buyer_full_name'],
        'buyerPhone': !exists(json, 'buyer_phone') ? undefined : BuyerPhoneFromJSON(json['buyer_phone']),
        'buyerEmail': !exists(json, 'buyer_email') ? undefined : BuyerEmailFromJSON(json['buyer_email']),
        'buyerRepresentation': BuyerRepresentationFromJSON(json['buyer_representation']),
        'buyerAgentFullName': !exists(json, 'buyer_agent_full_name') ? undefined : BuyerAgentFullNameFromJSON(json['buyer_agent_full_name']),
        'buyerAgentPhone': !exists(json, 'buyer_agent_phone') ? undefined : BuyerAgentPhoneFromJSON(json['buyer_agent_phone']),
        'buyerAgentEmail': !exists(json, 'buyer_agent_email') ? undefined : BuyerAgentEmailFromJSON(json['buyer_agent_email']),
        'offerPrice': json['offer_price'],
        'financingTypes': ((json['financing_types'] as Array<any>).map(FinancingTypeFromJSON)),
        'downPayment': !exists(json, 'down_payment') ? undefined : json['down_payment'],
        'earnestMoneyDeposit': json['earnest_money_deposit'],
        'dueDiligencePeriodDays': json['due_diligence_period_days'],
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'closingDate': json['closing_date'],
        'titleCompany': json['title_company'],
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentage1FromJSON(json['buyer_agent_commission_percentage']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'requestSellerConcessions': json['request_seller_concessions'],
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentage1FromJSON(json['concessions_percentage']),
        'submissionAdditionalTerms': !exists(json, 'submission_additional_terms') ? undefined : SubmissionAdditionalTermsFromJSON(json['submission_additional_terms']),
        'additionalComments': !exists(json, 'additional_comments') ? undefined : AdditionalCommentsFromJSON(json['additional_comments']),
        'source': !exists(json, 'source') ? undefined : CreateOfferRequestSourceFromJSON(json['source']),
        'receivedAt': !exists(json, 'received_at') ? undefined : ReceivedAtFromJSON(json['received_at']),
        'sendEmail': !exists(json, 'send_email') ? undefined : json['send_email'],
        'helpscoutLink': !exists(json, 'helpscout_link') ? undefined : json['helpscout_link'],
        'manualEntryReason': !exists(json, 'manual_entry_reason') ? undefined : ManualEntryReasonFromJSON(json['manual_entry_reason']),
        'offerSource': !exists(json, 'offer_source') ? undefined : OfferSourceFromJSON(json['offer_source']),
        'lenderName': !exists(json, 'lender_name') ? undefined : json['lender_name'],
        'lenderContactName': !exists(json, 'lender_contact_name') ? undefined : json['lender_contact_name'],
        'lenderEmail': !exists(json, 'lender_email') ? undefined : json['lender_email'],
        'lenderPhone': !exists(json, 'lender_phone') ? undefined : json['lender_phone'],
        'loanId': !exists(json, 'loan_id') ? undefined : json['loan_id'],
    };
}

export function CreateOfferRequestToJSON(value?: CreateOfferRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'listing_id': value.listingId,
        'mls_id': MlsIdToJSON(value.mlsId),
        'buyer_full_name': value.buyerFullName,
        'buyer_phone': BuyerPhoneToJSON(value.buyerPhone),
        'buyer_email': BuyerEmailToJSON(value.buyerEmail),
        'buyer_representation': BuyerRepresentationToJSON(value.buyerRepresentation),
        'buyer_agent_full_name': BuyerAgentFullNameToJSON(value.buyerAgentFullName),
        'buyer_agent_phone': BuyerAgentPhoneToJSON(value.buyerAgentPhone),
        'buyer_agent_email': BuyerAgentEmailToJSON(value.buyerAgentEmail),
        'offer_price': value.offerPrice,
        'financing_types': ((value.financingTypes as Array<any>).map(FinancingTypeToJSON)),
        'down_payment': value.downPayment,
        'earnest_money_deposit': value.earnestMoneyDeposit,
        'due_diligence_period_days': value.dueDiligencePeriodDays,
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'closing_date': value.closingDate,
        'title_company': value.titleCompany,
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentage1ToJSON(value.buyerAgentCommissionPercentage),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'request_seller_concessions': value.requestSellerConcessions,
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentage1ToJSON(value.concessionsPercentage),
        'submission_additional_terms': SubmissionAdditionalTermsToJSON(value.submissionAdditionalTerms),
        'additional_comments': AdditionalCommentsToJSON(value.additionalComments),
        'source': CreateOfferRequestSourceToJSON(value.source),
        'received_at': ReceivedAtToJSON(value.receivedAt),
        'send_email': value.sendEmail,
        'helpscout_link': value.helpscoutLink,
        'manual_entry_reason': ManualEntryReasonToJSON(value.manualEntryReason),
        'offer_source': OfferSourceToJSON(value.offerSource),
        'lender_name': value.lenderName,
        'lender_contact_name': value.lenderContactName,
        'lender_email': value.lenderEmail,
        'lender_phone': value.lenderPhone,
        'loan_id': value.loanId,
    };
}

